<script lang="ts" setup>
import { useRouter } from 'vue-router'
import { useDisplay } from 'vuetify'

import tree1 from '@images/svg/tree1.svg?url'
import tree3 from '@images/svg/tree3.svg?url'
import authV2MaskDark from '@images/pages/mask-v2-dark.png'
import authV2MaskLight from '@images/pages/mask-v2-light.png'
import { ERouteNames } from '@/router/ERouteNames'

const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark)

const router = useRouter()
const { mdAndUp, smAndDown } = useDisplay()

const goToPreviousRoute = () => {
  if (window.history.state.back) {
    router.go(-1)
  } else {
    router.push({ name: ERouteNames.USER_PROFILE })
  }
}
</script>

<template>
  <div class="layout-blank">
    <VRow
      align="center"
      :class="{ 'px-3': smAndDown }"
      class="auth-wrapper min-h-100dvh"
      justify="center"
      no-gutters
    >
      <VCol
        class="d-flex align-center justify-center"
        cols="12"
        md="6"
        lg="4"
      >
        <div class="d-flex flex-column align-center ga-4">
          <img
            src="/img/idao404.png"
            alt="Страница не найдена"
            class="page-not-found__img"
          >
          <div class="d-flex flex-column align-center ga-2">
            <h1 class="text-h1 title ma-0">
              Ошибка 404
            </h1>
            <h2 class="text-h4 subtitle ma-0">
              Страница не найдена
            </h2>
          </div>
          <VBtn
            prepend-icon="ri-arrow-left-line"
            @click="goToPreviousRoute"
          >
            Вернуться назад
          </VBtn>
        </div>
      </VCol>
    </VRow>

    <!-- Декорации - только для десктопа -->
    <div
      v-if="mdAndUp"
      aria-hidden="true"
      class="auth-decorations"
    >
      <img
        :src="authThemeMask"
        alt="footer mask"
        class="auth-footer-mask"
      >
      <VImg :src="tree1" alt="tree image" class="auth-footer-tree" />
      <VImg :src="tree3" alt="tree image" class="auth-footer-tree-1" />
      <VImg :src="tree3" alt="tree image" class="auth-footer-tree-2" />
    </div>
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth";

.title {
  color: rgb(var(--v-theme-primary-500)) !important;
}

.subtitle {
  color: rgba(var(--v-theme-text-secondary), var(--v-medium-emphasis-opacity)) !important;
}

.page-not-found__img {
  block-size: auto;
  max-block-size: 220px;
  max-inline-size: min(280px, 70vw);
  object-fit: contain;
}
</style>
